import OtherSpentRow from './OtherSpentRow'

const ViewByDaysOtherSpentRow = function($containerEl, dayModel, last)
{
    OtherSpentRow.call(this, $containerEl, dayModel.otherTTInfo);
    this.dayModel = dayModel;
    this.last = last;
};

ViewByDaysOtherSpentRow.prototype = _.create(OtherSpentRow.prototype, {
    html: "<tr class='otherSpentRow'>" +
          "  <td class='nameColumn'><div class='subContainer'><%-otherLabel%></div></td>" +
          "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" +
          "  <td class='detailsColumn'></td>" +
          "</tr>",

    afterRender: function()
    {
        this.$el.toggleClass("locked", this.dayModel.locked);
        this.$el.toggleClass("nonWorking", this.dayModel.workdayDuration == 0);
        this.$el.toggleClass("nonLast", !this.last);
    },

    templateModel: function()
    {
        var baseTemplateModel = this.baseTemplateModel();
        return {
            otherLabel: baseTemplateModel.otherLabel,
            total: baseTemplateModel.total
        }
    }
});

export default ViewByDaysOtherSpentRow



// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/ViewByDaysOtherSpentRow.js